import { IString } from '../../../model';
import { CollapseColumnRenderType } from '../model';

const oIndex: IString<number> = {};

export const addEmptyBody = (
  type: CollapseColumnRenderType,
  index: number,
  rowSpanLen?: number
) => {
  const key = `${type}-${index}`;
  if (oIndex[key]) {
    return null;
  }

  oIndex[key] = index;
  if (type === CollapseColumnRenderType.Body && rowSpanLen) {
    return <td className="empty-column" rowSpan={rowSpanLen}></td>;
  }
  return <th className="empty-column"></th>;
};

export const removeIndexCache = (
  type: CollapseColumnRenderType,
  index?: number
) => {
  if (
    type === CollapseColumnRenderType.Header ||
    type === CollapseColumnRenderType.Body
  ) {
    Object.keys(oIndex).forEach((item) => {
      if (item.startsWith(type)) {
        delete oIndex[item];
      }
    });
    return;
  }

  const key = `${type}-${index}`;
  delete oIndex[key];
};

Object.assign(window, {
  oIndex,
});
